<div class="dialog-header">
    <h2 mat-dialog-title>Management Fee Settings</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="managementFeeSettingsForm">
        <div class="key-value-pair-column">
            <div class="key-value-pair" style="border-bottom: none">
                <div class="key-value-item">Scaling Factor</div>
                <div class="key-value-item">
                    <input matInput
                        class="input-number-narrow"
                        type="number"
                        [formControl]="managementFeeSettingsForm.controls.scalingFactor"
                        data-test="management-fee-scaling-factor-input">
                </div>
            </div>
            <mat-slider style="width: 90%;"
                [min]="0"
                [max]="speedOptions.length - 1"
                [step]="1">
                <input matSliderThumb
                    [value]="getSliderIndex()"
                    (valueChange)="onSliderChange($event)">
            </mat-slider>
            <div class="slider-labels">
                <span>0%</span>
                <span style="text-align: center;">100%</span>
                <span style="text-align: right;">500%</span>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-stroked-button
        mat-dialog-close
        color="primary"
        [disabled]="managementFeeSettingsForm.invalid"
        (click)="save()"
        data-test="save-button">
        Save
    </button>
</mat-dialog-actions>
